var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9417 4.22248L11.5527 0.775986C11.1891 0.406278 10.6963 0.196777 10.1833 0.196777H1.93891C0.868471 0.200885 0 1.08408 0 2.17266V19.2614C0 20.3499 0.868471 21.2331 1.93891 21.2331H13.5724C14.6428 21.2331 15.5113 20.3499 15.5113 19.2614V5.61915C15.5113 5.09746 15.3053 4.59219 14.9417 4.22248ZM13.4148 5.45895H10.3409V2.33287L13.4148 5.45895ZM1.93891 19.2614V2.17266H8.40195V6.44484C8.40195 6.99118 8.83416 7.43072 9.3714 7.43072H13.5724V19.2614H1.93891Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88402 11.9291L8.61727 10.438H9.85271L8.59878 12.6624L9.8866 14.9238H8.63884L7.88402 13.4049L7.1292 14.9238H5.88451L7.16925 12.6624L5.9184 10.438H7.15076L7.88402 11.9291Z",
    fill: "#95AAC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5113,
    height: 21.0323,
    fill: "white",
    transform: "translate(0 0.20166)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.d456923138edcdc2459b97550076dcfb.svg";
export { ForwardRef as ReactComponent };